import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiURI, mainSite } from '../config.js';
import Bugsnag from '@bugsnag/expo';

/** STATE OBJECT */
const initialState = {
  workout_loading_msg: 'idle',
  workout_results_msg: '',
  current_workout: {
    completed: 0,
    activities: [],
    id: 0,
    show_unlimited_play_button: false,
    show_workout_button: true,
    daily_workout_completed: false,
    workout_button_wording: 'Start Workout',
    workout_message: "It's time to pump the iron with today's workout!",
    workout_version:null
  },
  current_workout_activity: {
    id: null,
    name: null,
    label: null,
    shortcode: null,
    type: null,
  },
  workout_modal_messaging: null
};

export const fetchLatestWorkout = createAsyncThunk(
  'cbcWorkout/fetchLatestWorkout',
  async ({}, { rejectWithValue }) => {
    Bugsnag.leaveBreadcrumb('Action fetchLatestWorkout dispatched');
    const response = await fetch(`${apiURI}/start-client-workout.php`, {
      method: 'POST',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });

    const results = await response.json();
    // did we get a successful response
    if (response.ok) {
      // verfiy a successful authorization
      if (!results.success) {
        return rejectWithValue(results.msg);
      }

      return results.workout_details;
    } else {
      // return the status text from the response
      Bugsnag.notify('Api Error, start-client-workout: ' + response.text());
      return rejectWithValue(response.text());
    }
  }
);

/** DEFINE REDUCERS */
export const cbcWorkoutSlice = createSlice({
  name: 'cbcWorkout',
  initialState,
  reducers: {
    setCurrentWorkout(state, { payload }) {
      Bugsnag.leaveBreadcrumb('Action setCurrentWorkout dispatched');
      Bugsnag.leaveBreadcrumb('Current Workout Id: ' + payload.workout_id);
      state.current_workout.id = payload.workout_id;
      state.current_workout.completed = payload.workout_completed;
      state.current_workout.activities = payload.workout_activities;
    },
    setCurrentWorkoutActivity(state) {
      Bugsnag.leaveBreadcrumb('Action setCurrentWorkout dispatched');
      state.current_workout_activity = state.current_workout.activities.find(
        (activity) => activity.completed === 0
      );
      Bugsnag.leaveBreadcrumb(
        'Current Workout Activity: ' + state.current_workout_activity
      );
    },
    clearWorkoutStoreModalMessage(state){
      console.log('clearing workout_modal_messaging');
      state.workout_modal_messaging = null;
      console.log('cleared workout_modal_messaging' , state.workout_modal_messaging);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestWorkout.pending, (state) => {
        state.workout_loading_msg = 'pending';
        state.workout_results_msg = 'Verifying You Are Logged In...';
      })
      .addCase(fetchLatestWorkout.fulfilled, (state, { payload }) => {
        ////console.log('extra reducer fetchlatest payload: ', payload);
        state.workout_loading_msg = 'idle';
        state.workout_results_msg = '';
        state.current_workout.id = payload.workout_id;
        state.daily_workout_completed = payload.daily_workout_completed;
        state.current_workout.workout_sequence_number =
          payload.workout_sequence_number;
        state.current_workout.completed = payload.workout_completed;
        state.current_workout.activities = payload.workout_activities;
        state.current_workout_activity = payload.workout_activities.find(
          (activity) => activity.completed === 0
        );
        state.current_workout.show_unlimited_play_button =
          payload.show_unlimited_play_button;
        state.current_workout.show_workout_button = payload.show_workout_button;
        state.current_workout.workout_message = payload.workout_message;
        state.current_workout.workout_button_wording =
          payload.workout_button_wording;
        state.current_workout.workout_version = payload.workout_version;
        state.workout_modal_messaging = payload.workout_modal_messaging;
        console.log('latest workout payload' , payload.workout_modal_messaging);
        Bugsnag.leaveBreadcrumb('Latest Workout: ' + JSON.stringify(payload));
      })
      .addCase(fetchLatestWorkout.rejected, (state, { payload }) => {
        state.workout_loading_msg = 'failed';
        state.workout_results_msg = payload;
      });
  },
});

// extract the action creators object and the reducer
const { reducer, actions } = cbcWorkoutSlice;

export const { setCurrentWorkout, setCurrentWorkoutActivity, clearWorkoutStoreModalMessage} = actions;

// export the reducer
export default reducer;
